import { BenefitProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BenefitProposalForm/data/formData';
import {
  CommonFormDataToLegacyPayloadProps,
  CommonLegacySubmitAttachmentData,
  LegacyProposalRequestProps,
  mapSubmitDataUtils,
  submitLegacyProposal,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

import { LegacyProposalAPI } from '../../../data';

export type BenefitSubmitData = {
  fEmplId: number;
  fEmplSubUId?: string;
  fBenefitProposalAmount: string;
  fBenefitProposalEndDate: string;
  fBenefitProposalFrequency: string;
  fBenefitProposalHigherMgrId: string; // number?
  fBenefitProposalHrId: number;
  fBenefitProposalInfo: string;
  fBenefitProposalManagerId: number;
  fBenefitProposalStartDate: string;
  fBenefitProposalStatus: string;
  fBenefitProposalTaxableAmount: string;
  fBenefitProposalType: string;
} & CommonLegacySubmitAttachmentData;

export const mapFormDataToLegacyPayload = (
  props: CommonFormDataToLegacyPayloadProps<BenefitProposalFormData>,
): BenefitSubmitData | FormData => {
  const {
    data,
    isHRUser,
    decision,
    requestProps: { employeeId, proposalId },
  } = props;
  const {
    submissionResponsibleHR,
    submissionDateInFormat,
    submissionProposalStatus,
  } = mapSubmitDataUtils({ defaultSubmissionDateFormat: 'YYYY-MM-DD' });

  const payloadCommon = {
    fEmplId: +data.employmentId || employeeId,
    fEmplSubUId: proposalId,
    fBenefitProposalAmount: data.benefitAmount
      ? data.benefitAmount.toString()
      : '',
    fBenefitProposalEndDate: submissionDateInFormat(data.endDate),
    fBenefitProposalFrequency: data.benefitFrequency,
    fBenefitProposalHigherMgrId: '-1',
    fBenefitProposalHrId: submissionResponsibleHR(data.responsibleHR),
    fBenefitProposalInfo: data.info || '',
    fBenefitProposalManagerId: -1,
    fBenefitProposalStartDate: submissionDateInFormat(data.startDate),
    fBenefitProposalStatus: submissionProposalStatus({ isHRUser, decision }),
    fBenefitProposalTaxableAmount: data.taxableAmount
      ? data.taxableAmount.toString()
      : '',
    fBenefitProposalType: data.benefitType,
  };

  // JSON Payload
  if (!data.attachment) {
    return {
      ...payloadCommon,
      fEmplAttachment: {
        fAttachmentId: data.attachmentId || -1,
        fAttachmentName: data.attachmentName || '',
      },
    };
  }

  // FormData payload
  const formData = new FormData();
  Object.entries(payloadCommon).forEach((sbData) => {
    if (sbData[1] !== null && sbData[1] !== undefined) {
      formData.append(
        sbData[0],
        typeof sbData[1] === 'string' ? sbData[1] : sbData[1].toString(),
      );
    }
  });
  formData.append('file', data.attachment);
  formData.append('fEmplAttachment.fAttachmentName', data.attachment.name);
  return formData;
};

export const submitBenefitProposal = async (
  data: BenefitSubmitData | FormData,
  requestProps: LegacyProposalRequestProps,
) =>
  submitLegacyProposal<BenefitSubmitData>(
    LegacyProposalAPI.BenefitProposal,
    data,
    requestProps,
  );
